import { createAction } from 'redux-actions';

export const UPDATE_WINDOW_SIZE = 'CLIENT.WINDOW_SIZE.UPDATE';
export const updateWindowSize = createAction(UPDATE_WINDOW_SIZE);
